import { render, staticRenderFns } from "./designation.vue?vue&type=template&id=9d6896da&scoped=true&"
import script from "./designation.vue?vue&type=script&lang=js&"
export * from "./designation.vue?vue&type=script&lang=js&"
import style0 from "./designation.vue?vue&type=style&index=0&id=9d6896da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6896da",
  null
  
)

export default component.exports